import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useConnection, useQuery } from "contexts";
import { vehicle_query } from "queries";
import { createContext, useContext, useEffect, useReducer, useState } from "react";
import { vehicle_reducer } from "reducers";
import auth_config from "../auth_config.json";

const initial_state = {
  header: [
    {
      display_name: "Vehicle ID",
      type: "Text",
      api_map: "id",
      style: {
        minWidth: "80px",
        maxWidth: "100px"
      }
    },
    {
      display_name: "Name",
      type: "Text",
      api_map: "displayName",
      style: {
        minWidth: "80px",
      }
    },
    // {
    //   display_name: "Lat",
    //   type: "Number",
    //   api_map: "lat",
    //   style: {
    //     minWidth: "80px",
    //   }
    // },
    // {
    //   display_name: "Lon",
    //   type: "Number",
    //   api_map: "lon",
    //   style: {
    //     minWidth: "80px",
    //   }
    // },
    {
      display_name: "Positioned",
      type: "Time",
      api_map: "positionedAt",
      style: {
        minWidth: "80px",
      }
    },
    {
      display_name: "Time Since Positioned",
      type: "Time",
      api_map: "timeSincePositioned",
      style: {
        minWidth: "80px",
      }
    },
    {
      display_name: "Electric",
      type: "Time",
      api_map: "isElectric",
      style: {
        minWidth: "80px",
      }
    },
  ],
  vehicles: null,
  filtered: [],
  filters: [],
  search_fields: [],
  display_fields: [],
  selected_vehicle: null,
  meta_map: {},
  display_names: [],
  search_names: [],
};

const VehicleContext = createContext();

function VehicleContextProvider({ children }){
  const state = initial_state;
  if (state.display_names.length + state.search_fields.length === 0) {
    state.header.forEach((header) => {
      state.display_names.push(header.display_name);
      state.search_fields.push(header.api_map);
      state.meta_map[header.display_name] = {
        id: header.api_map,
        style: header.style,
        type: header.type,
      };
    });
  }

  const [vehicles, dispatch] = useReducer(vehicle_reducer, state);

  return (
    <VehicleContext.Provider value={{ vehicles, dispatch }}>
      {children}
    </VehicleContext.Provider>
  );
};

function useVehicles() {
  const context = useContext(VehicleContext);
  const { vehicles, dispatch } = context;
  const { dispatch: conn_dispatch } = useConnection();
  const { logout, getAccessTokenSilently, error: auth0_error, user: auth0_user, isLoading } = useAuth0();

  // Alternately call it with mod 1, mod 0. This is to split the load on the server.

  // Call REST Api to get vehicles, every 20 seconds

  const client = axios.create({
    baseURL: process.env.REACT_APP_GEMINI_URL.replace("/graphql", "/api/v1/resources/vehicles/ui/"),
    timeout: 10000,
  });

  useEffect(() => {

    const fetchData = async () => {
      try {
        const accessToken = await getAccessTokenSilently({
          audience: auth_config.audience,
          scope: auth_config.scope,
        });
        client.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        const response = await client.get("/");
        const vehiclesData = response.data;
        console.log("Fetched vehicles data from API:", vehiclesData[0]);
        dispatch({ type: "REFRESH_VEHICLES", payload: vehiclesData });
        conn_dispatch({ type: "SET_CONN_SUCCESS" });
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        if (error.response && error.response.status >= 400 && error.response.status < 500) {
          // Redirect to logout
          logout({ returnTo: window.location.origin });
        }
        conn_dispatch({ type: "SET_CONN_ERROR" });
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 11000); // Fetch every 11 seconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  // }, [client, dispatch, conn_dispatch]);
  }, []);

  return context;
}

function useVehicle(id) {
  const [ vehicle, set_vehicle ] = useState(null)
  const { dispatch: conn_dispatch } = useConnection();
  const { data, loading, error } = useQuery(vehicle_query, { variables: { vehicle_id: id }, refetchInterval: 40000});

  useEffect(() => {
    if (error !== null) {
      console.error(error);
      conn_dispatch({ type: "SET_CONN_ERROR" });
      return;
    }

    if (!loading) {
      const { vehicle } = data;
      set_vehicle(vehicle);
      conn_dispatch({ type: "SET_CONN_SUCCESS" });
    }
  }, [conn_dispatch, data, loading, error])

  return vehicle;
}

export { useVehicle, useVehicles, VehicleContext, VehicleContextProvider };

